import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { shareReplay, startWith, Subject, switchMap, tap } from "rxjs";
import { Student } from "../models";

@Injectable({ providedIn: "root" })
export class StudentService {
  private readonly base = window.location.port === "4200" ? "/api" : "/api"; // dev et prod via /api

  private refresh$ = new Subject<void>();

  // flux public de la liste
  readonly aircrafts$ = this.refresh$.pipe(
    startWith(void 0), // premier chargement
    switchMap(() => this.http.get<Student[]>(`${this.base}/student`)),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(private http: HttpClient) {}

  getStudents() {
    return this.http.get<Student[]>(`${this.base}/student`);
  }
}
